import type { MoneyTotal, OrganizationDashboard } from '@/components/dashboard/types';

export interface SalesMonth {
  month: string; label: string; sales: number; billed: MoneyTotal; revenue: MoneyTotal;
}
export interface SalesCountry { country: string | null; customers: number; revenue: MoneyTotal }
export interface SalesReport {
  dashboard: OrganizationDashboard;
  period: { key: string; from: string; to: string }; scope: 'organization' | 'mine'; display_currency: string; brand_color: string; income_start_date: string | null;
  metrics: { sales: number | null; sales_change: number | null; active_customers: number | null; revenue: MoneyTotal | null; revenue_change: number | null; refunds: number | null; refunds_change: number | null; profit: MoneyTotal | null };
  months: SalesMonth[];
  top_products: Array<{ id: string; product_id: string | null; name: string; type: string; unit: string; quantity: string; currency: string; total: string; display_total: string | null }>;
  countries: SalesCountry[];
}

export function amountIn(money: MoneyTotal, currency: string): number | null {
  if (money.display?.currency === currency) return Number(money.display.total);
  const group = money.by_currency.find((row) => row.currency === currency);
  if (group) return Number(group.total);
  if (money.by_currency.length === 0) return 0;
  return null;
}

export function moneyText(money: MoneyTotal | null): string {
  if (!money) return '—';
  const groups = money.display ? [money.display] : money.by_currency;
  return groups.map((row) => `${row.currency} ${Number(row.total).toLocaleString(undefined, { maximumFractionDigits: 2 })}`).join(' · ') || '0';
}

export const currencyText = (amount: number, currency: string) => `${currency} ${amount.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
